/*============================================================================
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart

  Cart page behavior (quantity, remove, bundle/free-gift sync) and the small
  Shopify Ajax API helpers other scripts rely on.

  The slide-out cart (modal, drawer and flip) was removed. ajaxifyShopify.buildCart
  now sends the shopper to /cart instead.

  This requires:
    - jQuery 1.8+

  JQUERY API (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

function generateUniqueLineItemUid() {
  return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
}

/*============================================================================
  API Functions
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

Shopify.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};
Shopify.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = {};
  try {
    data = JSON.parse(XMLHttpRequest.responseText);
  } catch (e) {}
  alert(data.message ? data.message + '(' + data.status  + '): ' + data.description : 'Something went wrong. Please try again.');
};

// Get from cart.js returns the cart in JSON
Shopify.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    } else {
      Shopify.onCartUpdate(cart);
    }
    
  });
};

/*============================================================================
  Ajaxify Shopify Add To Cart
==============================================================================*/
var ajaxifyShopify = (function(module, $) {
  'use strict';

  var init;
  var settings, $cartCountSelector, $cartCostSelector;
  var updateCountPrice, buildCart, adjustCart, adjustCartCallback, validateQty;

  init = function(options) {
    settings = {
      cartCountSelector: null,
      cartCostSelector: null,
      moneyFormat: '$'
    };

    $.extend(settings, options);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);

    adjustCart();
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.find('span.money').html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
      $cartCostSelector.removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCostSelector.addClass('hidden-count');
      }
    }
  };

  /* Cart-less pages send the shopper to /cart; the cart page refreshes itself. */
  buildCart = function () {
    if (window.location.pathname.indexOf('/cart') === 0) {
      window.location.reload();
    } else {
      window.location.href = '/cart';
    }
  };

  adjustCart = function () {

    // This function runs on load, and when the cart is reprinted

      function splitLineItemOnCart(el) {
      var line = parseInt(el.closest('.itemLoop').attr('data-line'), 10);
      if (!line || isNaN(line)) return false;

      $('#cartWrapper').addClass('cart-remove-events');
      $('#cartWrapper .cart-checkout').addClass('loading');

      jQuery.getJSON('/cart.js', function(cart) {
        var item = cart && cart.items && cart.items[line - 1];
        if (!item) {
          $('#cartWrapper').removeClass('cart-remove-events');
          $('#cartWrapper .cart-checkout').removeClass('loading');
          return;
        }

        var props = item.properties || {};
        // Cart page "+" uses this path instead of qty "change". For main lines tied to free gifts,
        // adding only the main line leaves gifts behind — mirror the bundle add used on qty increase.
        if (props['_Has Free Gift'] === 'Yes' && props['_timestamp']) {
          var ts = props['_timestamp'];
          var giftItems = (cart.items || []).filter(function(ci) {
            return ci.properties &&
                   ci.properties['_Free Gift'] === 'Yes' &&
                   ci.properties['_timestamp'] === ts;
          });
          if (giftItems.length) {
            var newTimestamp = new Date().toISOString();
            var itemsToAdd = [];
            var mainPropsForNew = JSON.parse(JSON.stringify(props));
            mainPropsForNew['_Has Free Gift'] = 'Yes';
            mainPropsForNew['_timestamp'] = newTimestamp;
            mainPropsForNew['_line_item_uid'] = generateUniqueLineItemUid();
            var mainLine = { id: item.variant_id, quantity: 1, properties: mainPropsForNew };
            if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id) {
              mainLine.selling_plan = item.selling_plan_allocation.selling_plan.id;
            }
            itemsToAdd.push(mainLine);
            giftItems.forEach(function(giftItem) {
              var giftPropsForNew = JSON.parse(JSON.stringify(giftItem.properties || {}));
              giftPropsForNew['_Free Gift'] = 'Yes';
              giftPropsForNew['_timestamp'] = newTimestamp;
              giftPropsForNew['_line_item_uid'] = generateUniqueLineItemUid();
              itemsToAdd.push({
                id: giftItem.variant_id,
                quantity: 1,
                properties: giftPropsForNew
              });
            });
            RC.cart.add({ items: itemsToAdd }, function() {
              Shopify.getCart(function(updatedCart) {
                adjustCartCallback(updatedCart);
                $('#cartWrapper').removeClass('cart-remove-events');
                $('#cartWrapper .cart-checkout').removeClass('loading');
              });
            }, function() {
              $('#cartWrapper').removeClass('cart-remove-events');
              $('#cartWrapper .cart-checkout').removeClass('loading');
            });
            return;
          }
        }

        var splitProps = jQuery.extend({}, item.properties || {});
        splitProps['_line_item_uid'] = generateUniqueLineItemUid();

        var payload = {
          items: [{
            id: item.id,
            quantity: 1,
            properties: splitProps
          }]
        };

        if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id) {
          payload.items[0].selling_plan = item.selling_plan_allocation.selling_plan.id;
        }

        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: JSON.stringify(payload),
          dataType: 'json',
          contentType: 'application/json; charset=UTF-8',
          cache: false
        }).done(function() {
          Shopify.getCart(function(updatedCart) {
            adjustCartCallback(updatedCart);
            $('#cartWrapper').removeClass('cart-remove-events');
            $('#cartWrapper .cart-checkout').removeClass('loading');
          });
        }).fail(function() {
          $('#cartWrapper').removeClass('cart-remove-events');
          $('#cartWrapper .cart-checkout').removeClass('loading');
        });
      });

      return true;
    }
    // 

    // Update quantify selectors
	var qtyAdjust = $('.ajaxcart__qty-adjust');

    // Add or remove from the quantity
    qtyAdjust.off('click');
    qtyAdjust.on('click', function() {
      var el = $(this),
          id = el.data('id'),
          qtySelector = el.siblings('.ajaxcart__qty-num'),
          qty = parseInt(qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if (el.hasClass('ajaxcart__qty--plus')) {
          if (window.location.pathname.indexOf('/cart') > -1 && el.closest('.itemLoop').length) {
          splitLineItemOnCart(el);
          return false;
        }
        qty = qty + 1;
      } else {
        qty = qty - 1;
        if (qty <= 0) qty = 0;
      }

      qtySelector.val(qty).trigger('change');
     
    });

    // Remove quantify selectors
	var productRemovEl = $('.ajaxcart__remove');

    // Completely remove product
    productRemovEl.off('click');
    productRemovEl.on('click', function(e) {
      var el = $(this),
          id = el.data('id') || null,
          qty = 0,
          qtySelector = el.parents('.itemLoop').find('.ajaxcart__qty-num'),
          type = $(this).data('type').trim(),
          title = $(this).data('title').trim(),
          variant = $(this).data('variant').trim();

      qtySelector.val(qty).trigger('change');
    if (typeof gtag !== 'undefined'){
      gtag('event', 'remove_from_cart', {"items": [{"id": id, "category": type, "name": title, "variant": variant}]});
    }
      e.preventDefault();
    });

    // Update quantity based on input on change
    var qtyInput = $('.ajaxcart__qty-num');
    qtyInput.off('change');
    qtyInput.on('change', function() {
      
      if(updation_in_progress == true) {
        return false;
      } else {
        updation_in_progress = true;
      }

      var el = $(this),
          id = el.data('id'),
          qty = parseInt(el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);
      var productIndex;
      var attachedIndex;
      var celliantID;

      $('#cartWrapper').addClass('cart-remove-events');
      $('#cartWrapper .cart-checkout').addClass('loading');
      
      var recycleProducts = [39775214567529, 39775213715561, 39775213551721, 39775216500841, 39775216762985, 39775217123433];

      jQuery.getJSON('/cart.js', function (cart, textStatus) {
        var cartItems = cart.items;
        var finalUpdation = {};

        for(var x = 0; x < cartItems.length; x++) {

          if(recycleProducts.indexOf(cartItems[x].id) > -1) {
            finalUpdation[cartItems[x].key] = 0;
          }
        }

        if(el.parents('.grid__item').hasClass('has-combo')) {
          
          var attachedID = el.parents('.grid__item').data('combo');

          for(var i = 0; i < cartItems.length; i++) {

            var hasFreeProperty = false;
            var hasFreeValue = 0;

            for (var property in cartItems[i].properties) {

              if(property == "_FREE") {
                hasFreeProperty = true;
              }

              if(property == "_combo") {
                hasFreeValue = cartItems[i].properties[property];
              }
            }

            if(hasFreeValue == attachedID && cartItems[i].variant_id == id && hasFreeProperty == false) {
              finalUpdation[cartItems[i].key] = qty;
              var product_old_count = cartItems[i].quantity;
              break;
            }
          }
          
          for(var j = 0; j < cartItems.length; j++) {

            var hasFreeProperty = false;

            for (var property in cartItems[j].properties) {
              if(property == "_FREE") {
                hasFreeProperty = true;
              }
            }

            if(cartItems[j].variant_id == attachedID && hasFreeProperty == true) {
              var attached_old_count = cartItems[j].quantity;

              if(Number(qty) > Number(product_old_count)) {
                var attached_new_count = Number(attached_old_count) + (Number(qty) - Number(product_old_count));
              } else {
                var attached_new_count = Number(attached_old_count) - (Number(product_old_count) - Number(qty));
              }
              
              finalUpdation[cartItems[j].key] = attached_new_count;

              break;
            }
          }
        } else {

          for(var i = 0; i < cartItems.length; i++) {

            var hasFreeProperty = false;

            for (var property in cartItems[i].properties) {

              if(property == "_FREE") {
                hasFreeProperty = true;
              }
            }

            if(cartItems[i].variant_id == id && hasFreeProperty == false) {
              finalUpdation[cartItems[i].key] = qty;
              var product_old_count = cartItems[i].quantity;
              break;
            }
          }
        }
        
        if(el.parents('.grid__item').hasClass('has-celliant')) {
          
          var celliantID = el.parents('.grid__item').data('celliant');

          for(var j = 0; j < cartItems.length; j++) {

            var hasCelliantProperty = false;

            for (var property in cartItems[j].properties) {

              if(property == "CELLIANT") {
                hasCelliantProperty = true;
              }
            }
            
            if(cartItems[j].variant_id == celliantID && hasCelliantProperty == true) {
              var attached_old_count = cartItems[j].quantity;

              if(Number(qty) > Number(product_old_count)) {
                var attached_new_count = Number(attached_old_count) + (Number(qty) - Number(product_old_count));
              } else {
                var attached_new_count = Number(attached_old_count) - (Number(product_old_count) - Number(qty));
              }
              
              finalUpdation[cartItems[j].key] = attached_new_count;

              break;
            }
          }
        }

        // Sync free gift quantities with main product quantities in cart
        var didCreateNewSet = false;
        for (var i = 0; i < cartItems.length; i++) {
          var item = cartItems[i];
          if (item.variant_id !== id) continue;
          var props = item.properties || {};
          if (props['_Has Free Gift'] !== 'Yes' || !props['_timestamp']) continue;
          var timestamp = props['_timestamp'];
          var mainOldQty = item.quantity;
          // Find all linked free gift items (same timestamp)
          var giftItems = cartItems.filter(function(ci) {
            return ci.properties &&
                   ci.properties['_Free Gift'] === 'Yes' &&
                   ci.properties['_timestamp'] === timestamp;
          });
          if (!giftItems.length) break;

          // If quantity increased, create a new set (main + gifts) with a fresh timestamp
          if (qty > mainOldQty) {
            var delta = qty - mainOldQty;
            var newTimestamp = new Date().toISOString();
            var itemsToAdd = [];

            // Main product for the new set
            var mainPropsForNew = JSON.parse(JSON.stringify(props || {}));
            mainPropsForNew['_Has Free Gift'] = 'Yes';
            mainPropsForNew['_timestamp'] = newTimestamp;
            itemsToAdd.push({
              id: item.variant_id,
              quantity: delta,
              properties: mainPropsForNew
            });

            // Free gift items for the new set
            giftItems.forEach(function(giftItem) {
              var giftPropsForNew = JSON.parse(JSON.stringify(giftItem.properties || {}));
              giftPropsForNew['_Free Gift'] = 'Yes';
              giftPropsForNew['_timestamp'] = newTimestamp;
              itemsToAdd.push({
                id: giftItem.variant_id,
                quantity: delta,
                properties: giftPropsForNew
              });
            });

            didCreateNewSet = true;

            RC.cart.add({ items: itemsToAdd }, function(cart) {
              adjustCartCallback(cart);
              updation_in_progress = false;
            });
          } else {
            // Quantity stayed the same or decreased – keep original sync behavior
            // Update main product quantity
            finalUpdation[item.key] = qty;
            if (qty === 0) {
              giftItems.forEach(function(giftItem) {
                finalUpdation[giftItem.key] = 0;
              });
            } else {
              giftItems.forEach(function(giftItem) {
                var newQty = giftItem.quantity + (qty - mainOldQty);
                finalUpdation[giftItem.key] = Math.max(newQty, 0); // prevent negatives
              });
            }
          }

          break;
        }

        // If we did not create a new main+gift set above, fall back to a normal cart.update
        if (!didCreateNewSet) {
          RC.cart.update({updates: finalUpdation}, function(cart) {
            adjustCartCallback(cart);
            updation_in_progress = false;
          });
        }
      });
      
      return false;
    });

    // Save note anytime it's changed
    var noteArea = $('textarea[name="note"]');
    noteArea.off('change');
    noteArea.on('change', function() {
      var newNote = $(this).val();

      // Simply updating the cart note in case they don't click update/checkout
      Shopify.updateCartNote(newNote, function(cart) {});
    });

    // Update additional cart buttons
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
    
	//Check Cart Slider Quantity
    $(".ajaxcart__qty .ajaxcart__qty-num").each(function(){
      var tempVal = $(this).val();
      if(tempVal <= 1){
          $(this).siblings(".ajaxcart__qty--minus").addClass("qty_num");
       }else{
          $(this).siblings(".ajaxcart__qty--minus").removeClass("qty_num");
       }
	});
    
    $(".itemLoop").each(function(){
        if($(this).hasClass("FreeItem")){
            $(".cart__body").append(this);
        }
    });    
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {

      if(window.location.href.indexOf("/cart") > -1) {
        location.reload();
      } else {
      	Shopify.getCart(buildCart);
      }
    }, 150)
  };

  validateQty = function (qty) {
    // Make sure we have a valid integer
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    buildCart: buildCart,
    updateCountPrice: updateCountPrice
  };

  return module;

}(ajaxifyShopify || {}, jQuery));

jQuery(window).on('resize', function(){  
  checkHeightonCart();
  });
function checkHeightonCart(){
  var getWindowH =jQuery(window).innerHeight()-130;   
  var getWindowwW = jQuery(window).innerWidth();
  var getemptyCartH = jQuery('.__empty_cart__wrappercontainer').innerHeight();
  var getInfoH = jQuery('._ajax_cart_help_content').innerHeight();
  var getCartBodyH = jQuery('.cart__body').innerHeight();
  var getCartFooterH = jQuery('.cart__footer').innerHeight();
  var needminH = (getCartBodyH+getCartFooterH+getInfoH+getemptyCartH);
  if(getWindowwW > 767){
    if(getWindowH < needminH ){
      jQuery('.cartForm_left_content').addClass('overflowCartContent');
    }else{
      jQuery('.cartForm_left_content').removeClass('overflowCartContent');
    }
  }
}

$(document).on('click',"#checkoutBtn",function(event){
	$(this).parents('.cart-checkout').addClass('loading');
});